import ReactRailsUJS from "react_ujs";
import ServerList from "./components/ServerList";

ReactRailsUJS.useContext({
    ServerList,
});
